module.exports = __webpack_public_path__ + "static/img/plus.4c4bf0a1.png";